import React from 'react'
import './Launch.css';
import PricingSection from './PricingSection';

const Launch = () => {
  return (
    <div className='LaunchContainer'>
        <div className='title'>Stock insights at your <span className='green'>fingertips.</span></div>
        <div className='subtitle'>Get the data you want when you need it.</div>
        <div className='ctaButtons'>
            <a className='customButton' href="/search">Try now →</a>
            <button className='customButton black'>How it works</button>
        </div>
        {/* <div className='photoCaption'>Browse our extensive data library covering info from many years</div> */}
        <img src={require("../assets/googl.png")} alt="Stockit" title="Stockit" className='previewPhoto' />
        <div className='PricingContent'>
        <div className='title'>Choose the plan that's right for <span className='green'>your business.</span></div>
        <div className='subtitle'>Subscribe today and cancel anytime.</div>
            <PricingSection/>
        </div>
        <div style={{marginBottom: '300px'}}></div>
    </div>
  )
}

export default Launch